import React from "react";
import { classNames } from "../styles/classNames";

interface DefinitionListItemProps {
  term: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  termClassName?: string;
  valueClassName?: string;
}

export default function DefinitionListItem({
  term,
  children,
  className,
  termClassName,
  valueClassName,
}: DefinitionListItemProps) {
  return (
    <div className={classNames("app-detail-row", className)}>
      <dt className={classNames("app-detail-term", termClassName)}>{term}</dt>
      <dd className={classNames("app-detail-value", valueClassName)}>{children}</dd>
    </div>
  );
}

